import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-clientes',
    templateUrl: './clientes.component.html',
    styleUrls: ['./clientes.component.css'],
    standalone: false
})
export class ClientesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
